import type { Plan } from '@ecomm/maps/types/Plan'
import { useTrackOdmonPlanSelection } from '@ecomm/tracking/useTrackOdmonPlanSelection'
import { useCallback } from 'react'
import { getCardData } from '../utils/getCardData'
import { Features } from './Features'
import { Footer } from './Footer'
import { Header } from './Header'

type Props = {
  readonly plan: Plan
  readonly showCartCTA: boolean
}

/**
 * MonitoringCard component
 * @param plan - The plan data to display in the card
 * @param showCartCTA - Whether to show the Add to Cart button
 * @returns JSX.Element | null
 */
export function MonitoringCard({ plan, showCartCTA }: Props) {
  const { badge, pricePerDay, description, features, name, sku } =
    getCardData(plan)

  const trackOdmonPlanSelection = useTrackOdmonPlanSelection()
  const cartCTAHandler = useCallback(() => {
    trackOdmonPlanSelection(name, 'cards')
  }, [trackOdmonPlanSelection, name])

  return (
    <li
      className="flex grow flex-col rounded-2xl border border-solid border-neutral-200 bg-neutral-100 overflow-hidden pb-3"
      data-testid="MonitoringCard"
    >
      <Header badge={badge}>{name}</Header>
      <div className="flex grow flex-col px-2">
        <Features features={features} />
        <section className="grow border-0 border-b border-solid border-neutral-200 px-5 py-6 text-center text-base">
          {description}
        </section>
        <Footer onClick={cartCTAHandler} showCartCTA={showCartCTA} sku={sku}>
          {pricePerDay}
        </Footer>
      </div>
    </li>
  )
}
